/**
 * 扫码签到相关接口地址：http://gitlab.10niu.cn/repository/editor?id=21&mod=608&itf=4041
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const signInQrcode = {
	// 扫码签到_学校二维码_列表
	getSchoolQrList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/qr_code_sign/v1/school_qr_code/list`,
			headers: config.headers,
			params
		});
	},
	// 扫码签到_学校二维码_新增
	addQrcode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/qr_code_sign/v1/school_qr_code/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 扫码签到_学校二维码_更新
	editQrcode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/qr_code_sign/v1/school_qr_code/update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 扫码签到_学校二维码_删除
	deleQrcode(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/qr_code_sign/v1/school_qr_code/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	}
};

export default signInQrcode;
